<template>
  <div class="index-page container">
    <n-card :loading="$var('load')" style="max-width: 1000px;">
      <h3 slot="header">Информация</h3>
      <n-form @submit="submit">
        <n-items style="margin-bottom: 10px;">
          <n-input title="Заголовок" v-bind="$form.input('title')" />
          <n-button color="primary" type="submit">Сохранить</n-button>
        </n-items>
      </n-form>
    </n-card>
  
    <n-card :loading="$var('loadDelete')" style="max-width: 1000px;">
      <h3 slot="header">Удаление проф. области</h3>
      Осторожно! Операция необратима!
      <br />
      <n-button color="danger" style="margin-top: 10px; font-size: .7em" @click="deleteModel">Удалить проф. область</n-button>
    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
  }),
  computed: {
    categoryId() {
      return this.$route.params.id
    },
  },
  mounted() {
    this.$form.init({
      title: '',
    })
    this.loadModel()
  },
  methods: {
    loadModel() {
      this.$var('load', true)
      $api.app.categories.get(this.categoryId).then((response) => {
        this.$form.init(response.data.content)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    submit() {
      this.$var('load', true)
      $api.app.categories.edit(this.categoryId, this.$form.get()).then((result) => {
        this.loadModel()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    deleteModel() {
      this.$var('loadDelete', true)
      $api.app.categories.delete(this.categoryId).then((response) => {
        this.$router.push({ name: 'categories.list', })
      }).finally(() => {
        this.$var('loadDelete', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
    --n-image-width: 180px;
    --n-image-height: 200px;
    
    .avatar {
      border: 2px solid red;
    }
  }
</style>
